import type {ReactElement, ReactNode} from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import {FontButton} from '@Components/contextual-menu/components/font-button';

interface ContextualMenuFontButtonProps {
  id: string;
  className?: string;
  label: string;
  selectedFontFamily: string;
  /**
   * for suboptions
   */
  children?: ReactNode;
  onClickFontButton(): void;
  isFontSuppported?: boolean;
  subOptionHasOverflow?: boolean;
}

export function ContextualMenuFontButton({
  className = '',
  subOptionHasOverflow = false,
  isFontSuppported = true,
  children = null,
  ...props
}: ContextualMenuFontButtonProps): ReactElement<any> {
  return (
    <Option
      key={props.id}
      className={className}
      label={props.label}
      subOptionHasOverflow={subOptionHasOverflow}
      optionControl={
        <FontButton
          data-testid={props.id.toUpperCase()}
          isFontSuppported={isFontSuppported}
          onClick={(): void => {
            props.onClickFontButton();
          }}
          selectedFontFamily={props.selectedFontFamily}
        />
      }
    >
      {children}
    </Option>
  );
}
